import { useState } from "react";
import "./ConversationLogVariable.css"
import TextInput from "/src/components/UI/TextField/TextInput";
const ConversationLogVariable = ({ variable }) => {
    const [copied, setCopied] = useState(false);

    const handleCopyValue = () => {
        navigator.clipboard.writeText(variable[1]);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="conversation_log_container_variable">
            
            <div className="conversation_log_name_variable" title={variable[0]} onClick={handleCopyValue}
> 
                {[variable[0]]}
            </div>
            {copied && <span className="copy-feedback">✓ Copied</span>}
            <TextInput className={"conversation_log_value_variable"} defaultValue={variable[1]} disabled/>
        </div>
    );
};

export default ConversationLogVariable;